import { PaginationType } from 'common';
import { TagsActionType } from 'enums';
import { TagType } from 'state';

export const setTags = (tags: TagType[]) =>
  ({ type: TagsActionType.SET_TAGS, tags } as const);

export const setTagsAfterScroll = (tags: TagType[]) =>
  ({ type: TagsActionType.SET_TAGS_AFTER_SCROLL, tags } as const);

export const searchTags = (search: string) =>
  ({ type: TagsActionType.SEARCH_TAGS, search } as const);

export const setTagsPagination = (pagination: PaginationType) =>
  ({ type: TagsActionType.SET_TAGS_PAGINATION, pagination } as const);
